import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { SignatureAuditPageModel } from "../pageModels/SignatureAuditPageModel";
import { SignatureAudit } from "../../models/SignatureAudit";
import Loading from "../../components/Loading/Loading";
import { globalStore } from "../../models/globalStore";
import { ImagePreview } from "../../components/ImagePreview";
import { DateUtil } from "../../utils/DateUtil";

const pageModel = new SignatureAuditPageModel();

const SignatureAuditPage: React.FC = observer(() => {
    const [activeTab, setActiveTab] = useState<"pending" | "processed">("pending");
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewSrc, setPreviewSrc] = useState("");

    useEffect(() => {
        globalStore.selectedMenuKey = "signature-audit";
        pageModel.loadCandidates();
        pageModel.loadProcessed();
    }, []);

    const openSignaturePreview = (signatureUrl: string) => {
        setPreviewSrc(signatureUrl);
        setPreviewVisible(true);
    };

    const closePreview = () => {
        setPreviewVisible(false);
        setPreviewSrc("");
    };

    const handleApprove = (audit: SignatureAudit) => {
        pageModel.setSelectedAudit(audit);
        pageModel.setShowConfirmDialog(true);
    };

    const handleRefuse = (audit: SignatureAudit) => {
        pageModel.setSelectedAudit(audit);
        pageModel.setShowRefuseDialog(true);
    };

    const renderAuditList = (audits: SignatureAudit[]) => {
        return (
            <div style={{ padding: "20px" }}>
                {audits.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px", color: "#999", fontWeight: 300 }}>
                        暂无数据
                    </div>
                ) : (
                    audits.map(audit => (
                        <div
                            key={audit.id}
                            style={{
                                padding: "15px",
                                border: "1px solid #eee",
                                marginBottom: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "20px", flex: 1 }}>
                                <div style={{ fontSize: "14px", fontWeight: 300, minWidth: "120px" }}>
                                    <span style={{ color: "#666" }}>用户昵称：</span>{audit.nickname}
                                </div>
                                <div style={{ fontSize: "14px", fontWeight: 300, minWidth: "100px" }}>
                                    <span style={{ color: "#666" }}>用户类型：</span>{audit.submitterType === 0 ? "买家" : "卖家"}
                                </div>
                                <div style={{ fontSize: "14px", fontWeight: 300, minWidth: "120px" }}>
                                    <span style={{ color: "#666" }}>真实姓名：</span>{audit.realName}
                                </div>
                                <div style={{ fontSize: "14px", fontWeight: 300 }}>
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            openSignaturePreview(audit.signatureUrl);
                                        }}
                                        style={{
                                            color: "#1677ff",
                                            textDecoration: "none",
                                            fontWeight: 300
                                        }}
                                    >
                                        点击查看签名
                                    </a>
                                </div>
                                <div style={{ fontSize: "14px", fontWeight: 300, color: "#666", minWidth: "160px" }}>
                                    <span style={{ color: "#666" }}>提交时间：</span>
                                    {audit.submitTime ? DateUtil.formatDatetime(audit.submitTime) : "-"}
                                </div>
                                {audit.lastRefuseReason && (
                                    <div style={{ fontSize: "14px", fontWeight: 300, color: "#ff4d4f", flex: 1 }}>
                                        上次拒绝理由：{audit.lastRefuseReason}
                                    </div>
                                )}
                            </div>
                            {activeTab === "pending" && (
                                <div style={{ display: "flex", gap: "10px", marginLeft: "20px" }}>
                                    <button
                                        style={{
                                            padding: "6px 12px",
                                            background: "#52c41a",
                                            color: "white",
                                            border: "none",
                                            cursor: "pointer",
                                            fontWeight: 400,
                                            fontSize: "14px"
                                        }}
                                        onClick={() => handleApprove(audit)}
                                    >
                                        通过审核
                                    </button>
                                    <button
                                        style={{
                                            padding: "6px 12px",
                                            background: "#ff4d4f",
                                            color: "white",
                                            border: "none",
                                            cursor: "pointer",
                                            fontWeight: 400,
                                            fontSize: "14px"
                                        }}
                                        onClick={() => handleRefuse(audit)}
                                    >
                                        拒绝通过
                                    </button>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        );
    };

    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column", fontWeight: 300 }}>
            <div style={{ padding: "30px 20px", paddingBottom: "0px" }}>
                <button
                    style={{
                        padding: "8px 16px",
                        marginRight: "10px",
                        border: "none",
                        background: activeTab === "pending" ? "#1890ff" : "#f5f5f5",
                        color: activeTab === "pending" ? "white" : "#666",
                        cursor: "pointer",
                        fontWeight: 400,
                        fontSize: "14px"
                    }}
                    onClick={() => setActiveTab("pending")}
                >
                    待审核
                </button>
                <button
                    style={{
                        padding: "8px 16px",
                        border: "none",
                        background: activeTab === "processed" ? "#1890ff" : "#f5f5f5",
                        color: activeTab === "processed" ? "white" : "#666",
                        cursor: "pointer",
                        fontWeight: 400,
                        fontSize: "14px"
                    }}
                    onClick={() => setActiveTab("processed")}
                >
                    已审核
                </button>
            </div>

            <div style={{ flex: 1, overflow: "auto" }}>
                {renderAuditList(activeTab === "pending" ? pageModel.candidates : pageModel.processed)}
            </div>

            {pageModel.showConfirmDialog && pageModel.selectedAudit && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 300
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 400, fontSize: "16px" }}>确认审核通过</h3>
                        <p style={{ fontWeight: 300, fontSize: "14px" }}>确认该用户的实名姓名和签名匹配吗？</p>
                        <div style={{ marginTop: "24px", textAlign: "right" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 300,
                                    fontSize: "14px"
                                }}
                                onClick={() => pageModel.setShowConfirmDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#52c41a",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400,
                                    fontSize: "14px"
                                }}
                                onClick={() => pageModel.approveAudit(pageModel.selectedAudit!.id)}
                            >
                                确认通过
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.showRefuseDialog && pageModel.selectedAudit && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 300
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 400, fontSize: "16px" }}>拒绝通过</h3>
                        <div style={{ marginBottom: "16px" }}>
                            <label style={{ 
                                display: "block", 
                                marginBottom: "8px", 
                                fontSize: "14px", 
                                color: "#333",
                                fontWeight: 300
                            }}>
                                拒绝原因
                            </label>
                            <textarea
                                value={pageModel.refuseReason}
                                onChange={(e) => pageModel.setRefuseReason(e.target.value)}
                                style={{
                                    width: "100%",
                                    height: "100px",
                                    padding: "8px",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "0",
                                    fontSize: "14px",
                                    fontWeight: 300,
                                    resize: "none"
                                }}
                                placeholder="请输入拒绝原因"
                            />
                        </div>
                        <div style={{ textAlign: "right", marginTop: "16px" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 300,
                                    fontSize: "14px"
                                }}
                                onClick={() => pageModel.setShowRefuseDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#ff4d4f",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400,
                                    fontSize: "14px"
                                }}
                                onClick={() => pageModel.refuseAudit(pageModel.selectedAudit!.id)}
                                disabled={!pageModel.refuseReason}
                            >
                                确认
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ImagePreview 
                visible={previewVisible} 
                src={previewSrc} 
                title="签名预览" 
                onClose={closePreview} 
            />

            {pageModel.loading && <Loading />}
        </div>
    );
});

export default SignatureAuditPage;

